// extracted by mini-css-extract-plugin
module.exports = {"green-button":"ProviderTable_green-button__1zXJE"};